import { Navigate, useLocation, useParams } from 'react-router-dom';

export const ProposalRedirect = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const venueId = params.get('venueId');
    const { proposalId } = useParams<{ proposalId: string }>();

    if (venueId && proposalId) {
        return <Navigate to={`/os/venues/${venueId}/proposals/${proposalId}`} replace />;
    }

    return <Navigate to="/os/inquiries" replace />;
};
